import { UPDATE_SELECTOR, UPDATE_TAG_FORM } from '../actions/types';
import { formValueSelector } from 'redux-form';

// Create base selector outside the reducer
export const tagFormSelector = formValueSelector('tagForm');

// Store current form name
let currentFormName = 'tagForm';

// Export a function that returns the appropriate selector
export const getTagSelector = () => formValueSelector(currentFormName);

const initialState = {
  // Remove selector from state
  currentForm: 'tagForm',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTOR:
      // Update the current form name in both module variable and state
      currentFormName = action.payload;
      return {
        ...state,
        currentForm: action.payload,
      };
    case UPDATE_TAG_FORM:
      return { ...state, tagForm: action.payload };
    default:
      return state;
  }
}
